import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

const AdminProtectedRoute: React.FC = () => {
  const token = Cookies.get('token');
  const role = Cookies.get('role');
  const roles = Cookies.get('roles');

  // Ha nincs token vagy nem admin, akkor átirányítjuk a főoldalra
  if ((!token || roles !== 'ADMIN') && (!token || role !== 'ADMIN')) {
    return <Navigate to="/" />;
  }

  // Ha admin, akkor megjelenítjük a gyermek komponenseket
  return <Outlet />;
};

export default AdminProtectedRoute;
